import { render, staticRenderFns } from "./OproepNieuweBewoner.vue?vue&type=template&id=36734403&scoped=true&"
import script from "./OproepNieuweBewoner.vue?vue&type=script&lang=js&"
export * from "./OproepNieuweBewoner.vue?vue&type=script&lang=js&"
import style0 from "./OproepNieuweBewoner.vue?vue&type=style&index=0&id=36734403&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36734403",
  null
  
)

export default component.exports